import { Box } from '@mui/material';
import { getS3FLIconLink } from '../../../../util/utility';

const BgAnimationOnCompany = () => {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                zIndex: 1,
            }}
        >
            <video className="login-video-player" loop autoPlay muted={true} playsInline={true}>
                <source src={getS3FLIconLink('login-bg-video', 'webm')} type="video/webm" />
                <source src={getS3FLIconLink('login-bg-video', 'mp4')} type="video/mp4" />
            </video>
        </Box>
    );
};
export default BgAnimationOnCompany;
